import React, {useState} from "react";
import {
    getIdUtenteLoggato,
    getValoreFormattato, TIPO_ELEMENTO_BTN_AGGIUNGI,
    TIPO_ELEMENTO_FORMULA,
    TIPO_ELEMENTO_LABEL, TIPO_ELEMENTO_LISTA, TIPO_ELEMENTO_NOTA, TIPO_ELEMENTO_SEPARATORE,
    TIPO_ELEMENTO_SOTTOLIVELLO,
    TIPO_ELEMENTO_VALORE
} from "../../../../utility/common";
import TabellaKpiView from "./TabellaKpiView";
import {aggiungiSottolivelloKpiApi} from "../../services/KpiServices";

export default function TabellaKpiController({
                                                 tabella,
                                                 updateTabella,
                                                 modifica,
                                                 handlerChange,
                                                 formikRef,
                                                 idKpi,
                                                 id_tipo_imp_dati
                                             }) {

    const [showDettagli, setShowDettagli] = useState(false);
    const [elementoDettagli, setElementoDettagli] = useState();
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const token = localStorage.getItem('ns-access-token');
    const idUtenteLoggato = getIdUtenteLoggato(token);

    function getClasse(el, errors, submitCount) {
        let classe = '';

        if (parseInt(el.tipo) === TIPO_ELEMENTO_BTN_AGGIUNGI) {
            classe = 'sost-td-btn_aggiungi';
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_SOTTOLIVELLO) {
            classe = "sost-td-sottolivellolivello-kpi";
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_LABEL) {
            classe = "sost-td-label-kpi";
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_SEPARATORE) {
            classe = "sost-td-separatore-kpi";
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_FORMULA) {
            classe = 'sost-elemento-kpi-formula';
        }

        if (errors[el.cella] && submitCount > 0) {
            classe += ' sost-elemento-obbligatorio';
        }

        if (el.modificato && el.modificato === true) {
            classe += ' sost-elemento-modificato'
        }
        return classe;
    }

    function getValoreByTipo(el) {
        let valore = el.label || ' ';

        if (el.modificato === true) {
            valore = el.valore;
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_FORMULA
            || parseInt(el.tipo) === TIPO_ELEMENTO_VALORE
            || parseInt(el.tipo) === TIPO_ELEMENTO_NOTA) {
            valore = getValoreFormattato(el.valore, el.formatter);
        } else if (parseInt(el.tipo) === TIPO_ELEMENTO_LISTA) {
            valore = getValoreFormattato(el.valore, el.formatter);
        }

        // Se sono un ESRS senza topics_valori, non mostro il valore "1" caricato di default, ma mostro ""
        if (el.topics && el.topics.length > 0 && el.topics_valori && el.topics_valori.length === 0) {
            valore = '';
        }
        return valore;
    }

    function getValoreTopics(el) {
        let valore = '';
        if (el.topics.length > 0) {
            el.topics.map((item, index) => {
                valore = item.valore;
            })
        }
        return valore;
    }

    function getDescrTopics(el) {
        let descr = '';
        if (el.topics.length > 0) {
            el.topics.map((item, index) => {
                descr = item.descr;
            })
        }
        return descr;
    }

    function getClasseAllineamentoEl(el) {
        let classe = '';

        if (parseInt(el.tipo) === TIPO_ELEMENTO_FORMULA
            || parseInt(el.tipo) === TIPO_ELEMENTO_VALORE
            || parseInt(el.tipo) === TIPO_ELEMENTO_NOTA
            || parseInt(el.tipo) === TIPO_ELEMENTO_LISTA) {
            classe += ' text-center';
        }
        return classe;
    }

    function getIconaDettaglio(elemento) {
        return (
            ((elemento.testo_dettaglio && elemento.testo_dettaglio !== '') || (elemento.titolo_dettaglio && elemento.titolo_dettaglio !== '')) &&
            <i
                className="fas fa-info-circle ns-mouse-pointer ps-2"
                style={{
                    fontSize: "1.2rem"
                }}
                onClick={() => {
                    setElementoDettagli(elemento);
                    setShowDettagli(true);
                }}
            />
        );
    }

    function onHideDialog() {
        if (!showDettagli) return;
        setShowDettagli(false);
    }

    async function aggiungiRiga(el) {
        let tabellaClone = JSON.parse(JSON.stringify(tabella));

        // Recupero il sottolivello precedente a quello attuale
        let sottolivello = null;

        for (let l = 0; l < tabellaClone.length; l++) {
            if (tabellaClone[l].ordine == el.index_livello) {
                for (let sl = 0; sl < tabellaClone[l].sottolivelli.length; sl++) {
                    if (tabellaClone[l].sottolivelli[sl].ordine == el.index_sottolivello - 1) {
                        sottolivello = JSON.parse(JSON.stringify(tabellaClone[l].sottolivelli[sl]));
                        sottolivello.ordine = el.index_sottolivello;

                        tabellaClone[l].sottolivelli.splice(sl + 1, 0, sottolivello);
                        break
                    }
                }
            }
        }

        if (sottolivello) {
            const response = await aggiungiSottolivelloKpiApi(idKpi, id_tipo_imp_dati, tabellaClone, el.index_livello, el.index_sottolivello);
            if (response.data.result === 0) {
                updateTabella(response.data.data);
            } else {
                setModalMsg(response.data.description);
                setShow(true);
            }
        }
    }

    return (
        <TabellaKpiView
            elementoDettagli={elementoDettagli}
            formikRef={formikRef}
            tabella={tabella}
            getClasse={getClasse}
            getClasseAllineamentoEl={getClasseAllineamentoEl}
            getIconaDettaglio={getIconaDettaglio}
            getValoreByTipo={getValoreByTipo}
            handlerChange={handlerChange}
            modifica={modifica}
            showDettagli={showDettagli}
            onHideDialog={onHideDialog}
            getValoreTopics={getValoreTopics}
            getDescrTopics={getDescrTopics}
            idUtenteLoggato={idUtenteLoggato}
            aggiungiRiga={aggiungiRiga}
            showMsg={show}
            setShowMsg={setShow}
            modalMsg={modalMsg}
        />
    );
}